import { useState } from "react";
import { Card, CardBody, Collapse } from "reactstrap";
import { Image, P } from "../../../../../AbstractElements";
import { ActivityFeedTitle, Href } from "../../../../../Constants/Constants";
import { FriendData } from "../../../../../Data/Applications/SocialApp/SocialApp";
import { dynamicImage } from "../../../../../Utils";
import HeaderWithIcon from "../HeaderWithIcon";

const ActivityFeedClass = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <HeaderWithIcon Heading={ActivityFeedTitle} isOpen={isOpen} setIsOpen={setIsOpen} />
      <Collapse isOpen={isOpen}>
        <CardBody className="social-status filter-cards-view">
          {FriendData.map((data, index) => (
            <div className="d-flex" key={index}>
              <Image className="img-50 rounded-circle m-r-15" src={dynamicImage(`user/${data.imageName}`)} alt="user" />
              <div className="flex-grow-1">
                <span className="f-w-600 d-block">{data.title}</span>
                <P>
                  Commented on Shaun Park's <a href={Href}>Photo</a>
                </P>
                <span className="light-span">{data.time} Ago</span>
              </div>
            </div>
          ))}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default ActivityFeedClass;
